<template>
  <div class="map-controls-container" :style="{height:!!containerHeight?containerHeight+'px':'600px'}">
    <div class="map-info">
      <span class="mr-15">缩放比例：{{scale}}</span>
      <span class="mr-15">X轴座标：{{Math.round(shipImage.left / scale)}}</span>
      <span class="mr-15">Y轴座标：{{Math.round(shipImage.top / scale)}}</span>
      <!--<span class="mr-15">{{lines.length}}</span>-->
    </div>
    <div class="controls">
      <div class="item" title="放大" @click="setScaleAdd">
        <span class="zsf-icon zsf-icon-fangda"></span>
      </div>
      <div class="item" title="缩小" @click="setScaleCut">
        <span class="zsf-icon zsf-icon-suoxiao"></span>
      </div>
      <div class="item" title="移动">
        <span class="zsf-icon zsf-icon-mobile"></span>
      </div>
      <!--<div class="item" @click="moveMapForPixelBetween(1569,489)">移到指定位置</div>-->
    </div>
    <div class="map-box" :style="{height:!!containerHeight?containerHeight+'px':'600px'}" id="map">
      <div class="ship-img" :class="!movingFlag?'tran-all2':''" id="moveDiv"
           :style="{ background:'white url('+shipImage.url+') no-repeat',width:shipImage.width+'px',height:shipImage.height+'px',transform:'scale('+scale+')',left:shipImage.left+'px',top:shipImage.top+'px'}">
        <div v-if="personLocationIsShow" class="person-location"
             :style="{transform:'scale('+1/scale+')',left:personInStation.points[0].x+'px',top:personInStation.points[0].y+'px'}">{{personName}}在{{personInStation.name}}
        </div>
        <div class="svg-line-animation-box"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
          <div class="svg-box">
            <svg width="100%" height="100%" version="1.1" id="svg">
              <template v-for="(item2,index2) in lines">
                <!--<line data-animation="false" style="stroke:#aaa;" class="tran-all2"-->
                <!--:x1="item2.x1" :y1="item2.y1" :x2="item2.x2" :y2="item2.y2">-->
                <!--</line>-->
                <line data-animation="true"
                      :style="item2.type=='toggle_deck'?'stroke:#efefef':'stroke:red'"
                      class="animation-line"
                      :x1="item2.x1" :y1="item2.y1"
                      :x2="item2.x1" :y2="item2.y1"
                      :data-type="item2.type"
                      :data-delay="item2.delay"
                      :data-duration="item2.duration"
                      :data-x1="item2.x1"
                      :data-x2="item2.x2"
                      :data-y1="item2.y1"
                      :data-y2="item2.y2">
                </line>
              </template>
            </svg>
            <!--<span class="el-icon-s-open tran-all" v-if="lines.length" :style="{left:lines[lines.length-1].x1+'px',top:lines[lines.length-1].y1+'px'}"></span>-->
          </div>
        </div>
      </div>
    </div>
    <div id="style"></div>
  </div>
</template>

<script type="text/ecmascript-6">
  import $ from 'jquery';
  import {tool} from '../common/js/tool.js';
  let timer = null;
  export default{
    data(){
      return {
        thisDelay: 0,
        shipMapDataPoints: [],
        shipImage: {
          url: '',
          width: 0,
          height: 0,
          left: 0,
          top: 0,
        },
        distanceX: 0,
        distanceY: 0,
        containerInfo: {
          width: 0,
          height: 0
        },
        scale: 1,
        widthScale: 1,
        heightScale: 1,
        scaleStep: 0.05,
        movingFlag: false,
        svgLineIsShow: false,
        lines: [],
        personX: 0,
        personY: 0,
        personLocationIsShow: false,
        personInStation: {},
        personName: ''
      }
    },

    props: ['containerHeight', 'ship_img', 'points'],

    computed: {},

    created(){
      //console.log(tool.getExtent(1864, 1019, 1594, 1002))
    },

    mounted(){
      //console.error(tool.getExtent(0, 0, 3, 4));
      this.getShipImage();
      this.getMapSize();
      setTimeout(() => {
        this.setImageBecoming();
        this.monitorMove();
      }, 10);
      window.onresize = () => {
        this.getShipImage();
        this.getMapSize();
      };
    },

    methods: {

      showPersonLocation(station, personName){
        this.personLocationIsShow = true;
        this.personName = personName;
        this.personInStation = station;
        console.log(this.personInStation);
        console.log(this.personInStation.points[0].x)
        console.log(this.personInStation.points[0].y)
      },

      moveMapForPixelBetween(x, y){
        //console.log(x, y);
        this.scale = 0.4;
//        this.shipImage.left = (this.containerInfo.width - x * this.scale ) / 2;
//        this.shipImage.top = (this.containerInfo.height - y * this.scale) / 2 ;
        this.shipImage.left = (( this.shipImage.width  ) / 2 - x) * this.scale - this.containerInfo.width / 2;
        this.shipImage.top = ((this.shipImage.height  ) / 2 - y) * this.scale - this.containerInfo.height / 2;
      },

      clearLines(){
        clearTimeout(timer);
        timer = null;
        $('#svg').html('');
        this.lines = [];
      },

      startAnimation(lines){
        if (lines.length === 0) {
          return;
        }
        this.lines = lines;
        let _this = this;
        timer = setTimeout(() => {
          let dom = $('.animation-line');
          for (let i = 0; i < dom.length; i++) {
            (function (i) {
              let duration = Number(dom.eq(i).attr('data-duration'));
              let delay = Number(dom.eq(i).attr('data-delay'));
              let x1 = Number(dom.eq(i).attr('data-x1'));
              let x2 = Number(dom.eq(i).attr('data-x2'));
              let y1 = Number(dom.eq(i).attr('data-y1'));
              let y2 = Number(dom.eq(i).attr('data-y2'));
              let type = dom.eq(i).attr('data-type');
              //console.error(duration, delay, x1, y1, x2, y2, type);
              setTimeout(() => {
                let timeStep = 50;
                let step = duration / timeStep;
                //console.log(step);
                let xStep = (x2 - x1) / step;
                let yStep = (y2 - y1) / step;
                let count = 0;
                let a = setInterval(() => {
                  //if (type !== 'toggle_deck') {
                  dom.eq(i).attr('x2', Number(dom.eq(i).attr('x2')) + xStep);
                  dom.eq(i).attr('y2', Number(dom.eq(i).attr('y2')) + yStep);
                  //}
                  count++;
                  if (count >= step) {
                    clearInterval(a);
                  }
                }, timeStep);
                if (type === 'in') {
                  //_this.moveMapForPixelBetween(x1, y1);
                }
              }, delay);
              //console.log(delay)
            })(i);
          }
        }, 10)
      },

      monitorMove(){
        let _this = this;
        document.ondblclick = null;
        let moveDiv = document.getElementById('moveDiv');
        let isDrag = false;
        let dx, dy, positionX, positionY;
        moveDiv.onmousedown = function (evt) {
          evt = evt || window.event;
          //console.log(evt);
          //console.log(evt.offsetX, evt.offsetY);
          _this.movingFlag = true;
          isDrag = true;
          positionX = evt.clientX;
          positionY = evt.clientY;
          dx = moveDiv.offsetLeft;
          dy = moveDiv.offsetTop;
          document.onmousemove = function (evt) {
            evt = evt || window.event;
            _this.shipImage.left = dx + evt.clientX - positionX;
            _this.shipImage.top = dy + evt.clientY - positionY;
            return false;
          };
          document.onmouseup = function () {
            isDrag = false;
            _this.movingFlag = false;
            document.onmousemove = null;
            document.onmouseup = null;
          }
        }
      },

      setScaleAdd(){
        let scale = Math.round((this.scale + this.scaleStep) * 100) / 100;
        if (scale < 2) {
          this.scale = scale;
        } else {
          this.scale = 2;
          tool.message('不能再放大了！', 'warning');
        }
      },

      setScaleCut(){
        let scale = Math.round((this.scale - this.scaleStep) * 100) / 100;
        if (scale > 0.1) {
          this.scale = scale;
        } else {
          this.scale = 0.1;
          tool.message('不能再缩小了！', 'warning');
        }
      },

      resetImageBecoming(){
        this.scale = 1;
        this.shipImage.left = 0;
        this.shipImage.top = 0;
        console.log(this.shipImage);
      },

      //地图100%显示
      setImageBecoming(){
        let widthScale2 = this.containerInfo.width / this.shipImage.width;
        let heightScale2 = this.containerInfo.height / this.shipImage.height;
        this.widthScale = Math.floor(widthScale2 * 100) / 100;
        this.heightScale = Math.floor(heightScale2 * 100) / 100;
        //this.scale = this.widthScale > this.heightScale ? this.heightScale : this.widthScale;
        //this.scale = Math.floor((this.widthScale + 0.01) * 100) / 100;
        this.scale = Math.floor((this.heightScale + 0.01) * 100) / 100;
        //this.scale = 1;
        this.shipImage.left = 0;
        this.shipImage.top = 0;
        //console.log(this.scale, widthScale2, heightScale2, this.widthScale, this.heightScale);
        //console.log(this.shipImage);
      },

      getShipImageSize(){
        alert(this.shipImage.width + '|' + this.shipImage.height);
      },

      getMapSize(){
        let container = document.getElementById('map');
        this.containerInfo.width = container.clientWidth;
        this.containerInfo.height = container.clientHeight;
        //console.log(this.containerInfo.width + '|' + this.containerInfo.height);
      },

      getShipImage(){
        this.shipImage.width = this.ship_img.width;
        this.shipImage.height = this.ship_img.height;
        this.shipImage.url = this.ship_img.url ? require('../common/images/ship2.jpg') : '';
        //console.log(this.shipImage);
      }
    },

    filters: {
      getExtent(a, b, c, d){
        if (a && b && c && d) {
          console.log(a, b, c, d);
          console.log(tool.getExtent(a, b, c, d));
          return tool.getExtent(a, b, c, d);
        } else {
          return 0;
        }
      }
    },

    watch: {
      points: {
        handler(newValue, oldValue) {
          for (let i = 0; i < newValue.length; i++) {
            if (oldValue[i] !== newValue[i]) {
              //console.log(this.points);
              this.getLines();
            }
          }
        },
        deep: true
      },
    },

    components: {}
  }
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
  @import "../common/less/ship-map.less";
  @import "../common/less/variable.less";

  .person-location {
    width: 150px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: white;
    box-shadow: 0 0 10px #ccc;
    position: absolute;
    left: 300px;
    top: 300px;
    z-index: 99;
  }

  @keyframes depict98-2 {
    0% {
      stroke-dashoffset: 98;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation98-2 {
    stroke-dasharray: 98;
    animation-name: depict98-2;
    animation-iteration-count: 1;
  }

  .animate-stop {
    animation-play-state: paused;
  }

  @keyframes depict {
    from {
      stroke: rgba(255, 0, 0, 1);
      stroke-dashoffset: 1000;
    }
    to {
      stroke: rgba(255, 0, 0, 1);
      stroke-dashoffset: 0;
    }
  }

  .svg-box {
    width: 100%;
    height: 100%;
    position: relative;
    background: rgba(0, 0, 0, 0);
    svg line {
      stroke-width: 3;
      /*stroke-dasharray: 1000;*/
      /*animation-name: depict;*/
      /*!*animation-duration: 10s;*!*/
      /*animation-iteration-count: 1;*/
      /*stroke: rgba(255, 0, 0, 0.1);*/
    }
    span {
      position: absolute;
      font-size: 24px;
      margin: -12px 0 0 -12px;
      color: red;
      display: block;
      width: 30px;
      height: 30px;
      background: red;
      z-index: 99;
      border-radius: 50%;
    }
  }

  @keyframes depict1001-1 {
    0% {
      stroke-dashoffset: 1002;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation1001-1 {
    stroke-dasharray: 1002;
    animation-name: depict1001-1;
    animation-iteration-count: 1;
  }

  @keyframes depict98-2 {
    0% {
      stroke-dashoffset: 98;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation98-2 {
    stroke-dasharray: 98;
    animation-name: depict98-2;
    animation-iteration-count: 1;
  }

  @keyframes depict4-3 {
    0% {
      stroke-dashoffset: 4;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation4-3 {
    stroke-dasharray: 4;
    animation-name: depict4-3;
    animation-iteration-count: 1;
  }

  @keyframes depict98-4 {
    0% {
      stroke-dashoffset: 98;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation98-4 {
    stroke-dasharray: 98;
    animation-name: depict98-4;
    animation-iteration-count: 1;
  }

  @keyframes depict291-5 {
    0% {
      stroke-dashoffset: 291;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation291-5 {
    stroke-dasharray: 291;
    animation-name: depict291-5;
    animation-iteration-count: 1;
  }

  @keyframes depict44-6 {
    0% {
      stroke-dashoffset: 44;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation44-6 {
    stroke-dasharray: 44;
    animation-name: depict44-6;
    animation-iteration-count: 1;
  }

  @keyframes depict281-7 {
    0% {
      stroke-dashoffset: 281;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation281-7 {
    stroke-dasharray: 281;
    animation-name: depict281-7;
    animation-iteration-count: 1;
  }

  @keyframes depict252-8 {
    0% {
      stroke-dashoffset: 252;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation252-8 {
    stroke-dasharray: 252;
    animation-name: depict252-8;
    animation-iteration-count: 1;
  }

  @keyframes depict4-9 {
    0% {
      stroke-dashoffset: 4;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation4-9 {
    stroke-dasharray: 4;
    animation-name: depict4-9;
    animation-iteration-count: 1;
  }

  @keyframes depict252-10 {
    0% {
      stroke-dashoffset: 252;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation252-10 {
    stroke-dasharray: 252;
    animation-name: depict252-10;
    animation-iteration-count: 1;
  }

  @keyframes depict316-11 {
    0% {
      stroke-dashoffset: 316;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation316-11 {
    stroke-dasharray: 316;
    animation-name: depict316-11;
    animation-iteration-count: 1;
  }

  @keyframes depict271-12 {
    0% {
      stroke-dashoffset: 271;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation271-12 {
    stroke-dasharray: 271;
    animation-name: depict271-12;
    animation-iteration-count: 1;
  }

  @keyframes depict4-13 {
    0% {
      stroke-dashoffset: 4;
      stroke: rgba(255, 0, 0, 1);
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  .animation4-13 {
    stroke-dasharray: 4;
    animation-name: depict4-13;
    animation-iteration-count: 1;
  }
</style>
